import React from 'react'
import R from 'ramda'
import {estatePhoto} from 'conf'
import {FormattedMessage} from 'react-intl'

import photoUrlFormatter from '../utils/photoUrlFormatter' 

import EstatePartner from './EstatePartner'
import LikeButton from './LikeButton'
import EstateProximity from './EstateProximity'
import Spacer from './Spacer'
import Icon from './Icon'
import ImageWithLoaderAndDefault from './ImageWithLoaderAndDefault'
import EstateDescription from './EstateDescription'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'
import MoreButton from './MoreButton'
import Price from './Price'

const EstateSelectedCard = ({proximityScore, id, photos, address, price, rooms, partner, like, providerUrl, detailsUrl, onClick}) => {
  const fileName = R.path(['0', 'url'], photos)
  const formattedFileName = fileName ? photoUrlFormatter(fileName, id, 300) : undefined
  const photoUrl = formattedFileName ? estatePhoto(formattedFileName) : undefined
  return <div className="estate">
    
        <div className="media" style={{borderStyle:'solid', borderWidth:'3px', borderColor:'#0198be', height:'160px'}}>
          <div className="media-left">

            <div style={{position:'absolute'}}>
              <EstatePartner partner={partner} providerUrl={providerUrl} selected={true}/>              
            </div>

            <div className="estate-card-label" style={{position:'absolute', right:'3px', paddingRight:'2px', paddingLeft:'5px'}}>
              <Price amount={price} currency='CAD'/>
            </div>

            <div className="estate-card-label" style={{position:'absolute', right:'3px', top:'32px', paddingRight:'2px', paddingLeft:'5px'}}>
              <LikeButton estateId={id} like={like}/>
            </div>
            
            <div className="estate-card-label proximity" style={{position:'absolute', left:'3px', bottom:'3px', paddingRight:'2px', paddingLeft:'5px'}}>
              <EstateProximity proximityInSeconds={proximityScore} />
            </div>
            
            <ImageWithLoaderAndDefault defaultSrc="images/estate/maison_600.png"
                                       imgSrc={photoUrl}/>
                        
            
            <MoreButton text="▼" />  
          </div>
        </div>

  </div>
}

{/*

<div className="media-body">
            <EstateDescription id={id}
                               like={like}
                               address={address}
                               price={price}
                               rooms={rooms}
                               partner={partner}
                               providerUrl={providerUrl}
                               detailsUrl={detailsUrl}
                               proximityScore={proximityScore}/>
            
         </div>

*/}

EstateSelectedCard.PropTypes = {
  id: React.PropTypes.number.isRequired,
  like: React.PropTypes.bool,
  address: React.PropTypes.string.isRequired,
  price: React.PropTypes.number.isRequired,
  rooms: React.PropTypes.number.isRequired,
  photos: React.PropTypes.array.isRequired,
  partner: React.PropTypes.string.isRequired,
  providerUrl: React.PropTypes.string.isRequired,
  detailsUrl: React.PropTypes.string.isRequired,
  proximityScore: React.PropTypes.number.isRequired,
}
export default StatelessFuncToPureComponent(EstateSelectedCard)



/** WEBPACK FOOTER **
 ** ./app/components/EstateSelectedCard.jsx
 **/